import { render, staticRenderFns } from "./ActiveNumberItem.vue?vue&type=template&id=5467d672&scoped=true"
import script from "./ActiveNumberItem.vue?vue&type=script&lang=js"
export * from "./ActiveNumberItem.vue?vue&type=script&lang=js"
import style0 from "./ActiveNumberItem.vue?vue&type=style&index=0&id=5467d672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467d672",
  null
  
)

export default component.exports